import type { Template } from "@/types";

export const LA_05_H0_V5: Template[] = [
    {
        id: "la-05-h0v5-01",
        name: "LA 01 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h0_v5_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 93, y: 78, width: 227, height: 328, rotation: 0, imageRotation: 0 },
            { id: "2", x: 328, y: 78, width: 227, height: 328, rotation: 0, imageRotation: 0 },
            { id: "3", x: 563, y: 78, width: 227, height: 328, rotation: 0, imageRotation: 0 },
            { id: "4", x: 798, y: 78, width: 227, height: 328, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1033, y: 78, width: 227, height: 328, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-02",
        name: "LA 02 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h0_v5_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 52, width: 264, height: 380, rotation: 0, imageRotation: 0 },
            { id: "2", x: 272, y: 52, width: 264, height: 380, rotation: 0, imageRotation: 0 },
            { id: "3", x: 544, y: 52, width: 264, height: 380, rotation: 0, imageRotation: 0 },
            { id: "4", x: 816, y: 52, width: 264, height: 380, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1088, y: 52, width: 264, height: 380, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-03",
        name: "LA 03 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h0_v5_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 142, y: 161, width: 192, height: 277, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 161, width: 192, height: 277, rotation: 0, imageRotation: 0 },
            { id: "3", x: 719, y: 161, width: 192, height: 277, rotation: 0, imageRotation: 0 },
            { id: "4", x: 919, y: 161, width: 191, height: 277, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1118, y: 161, width: 191, height: 277, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-04",
        name: "LA 04 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h0_v5_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 167, y: 0, width: 342, height: 483, rotation: 0, imageRotation: 0 },
            { id: "2", x: 815, y: 40, width: 285, height: 402, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1107, y: 40, width: 107, height: 129, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1107, y: 177, width: 107, height: 129, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1107, y: 314, width: 107, height: 128, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-05",
        name: "LA 05 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h0_v5_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 341, y: 46, width: 134, height: 192, rotation: 0, imageRotation: 0 },
            { id: "2", x: 341, y: 245, width: 134, height: 192, rotation: 0, imageRotation: 0 },
            { id: "3", x: 201, y: 46, width: 133, height: 192, rotation: 0, imageRotation: 0 },
            { id: "4", x: 201, y: 245, width: 133, height: 192, rotation: 0, imageRotation: 0 },
            { id: "5", x: 846, y: 0, width: 337, height: 483, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-06",
        name: "LA 06 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h0_v5_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 131, y: 48, width: 273, height: 389, rotation: 0, imageRotation: 0 },
            { id: "2", x: 412, y: 48, width: 133, height: 191, rotation: 0, imageRotation: 0 },
            { id: "3", x: 412, y: 246, width: 133, height: 191, rotation: 0, imageRotation: 0 },
            { id: "4", x: 799, y: 86, width: 212, height: 311, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 86, width: 212, height: 311, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-07",
        name: "LA 07 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h0_v5_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 139, y: 40, width: 285, height: 402, rotation: 0, imageRotation: 0 },
            { id: "2", x: 431, y: 40, width: 107, height: 129, rotation: 0, imageRotation: 0 },
            { id: "3", x: 431, y: 177, width: 107, height: 129, rotation: 0, imageRotation: 0 },
            { id: "4", x: 431, y: 313, width: 107, height: 129, rotation: 0, imageRotation: 0 },
            { id: "5", x: 872, y: 40, width: 285, height: 402, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-08",
        name: "LA 08 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h0_v5_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 201, y: 46, width: 273, height: 391, rotation: 0, imageRotation: 0 },
            { id: "2", x: 877, y: 46, width: 134, height: 192, rotation: 0, imageRotation: 0 },
            { id: "3", x: 877, y: 245, width: 134, height: 192, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1018, y: 46, width: 133, height: 192, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 245, width: 133, height: 192, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-09",
        name: "LA 09 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h0_v5_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 106, y: 43, width: 322, height: 396, rotation: 0, imageRotation: 0 },
            { id: "2", x: 435, y: 43, width: 157, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 435, y: 245, width: 157, height: 195, rotation: 0, imageRotation: 0 },
            { id: "4", x: 599, y: 43, width: 321, height: 396, rotation: 0, imageRotation: 0 },
            { id: "5", x: 927, y: 43, width: 321, height: 396, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-10",
        name: "LA 10 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h0_v5_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 106, y: 43, width: 322, height: 397, rotation: 0, imageRotation: 0 },
            { id: "2", x: 435, y: 43, width: 321, height: 397, rotation: 0, imageRotation: 0 },
            { id: "3", x: 763, y: 43, width: 321, height: 397, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1091, y: 43, width: 157, height: 195, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1091, y: 245, width: 157, height: 195, rotation: 0, imageRotation: 0 }
        ],
    }
];